"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TTL_MILLISECONDS = exports.TTL = exports.TERM_TYPES = exports.TEKCUB_KEYS = exports.SOURCE_TYPES = exports.SESSION_STORAGE_KEY = exports.DEFAULT_VALUES = void 0;
const TERM_TYPES = exports.TERM_TYPES = {
  UNKNOWN: 'UNKNOWN',
  MONTH: 'MONTH',
  YEAR: 'YEAR'
};
const SOURCE_TYPES = exports.SOURCE_TYPES = {
  SERP: 'serp',
  FOS: 'ac',
  EMAIL: 'cm'
};
const DEFAULT_VALUES = exports.DEFAULT_VALUES = {
  currency: 'USD',
  market: 'en-US'
};
const TEKCUB_KEYS = exports.TEKCUB_KEYS = {
  SWP: 'sc_swp',
  PRECHECK_BFF_SAPI: 'sc_pcapi',
  PRECHECK_BFF_NODE: 'sc_npcapi'
};

// Configuration for session storage
const SESSION_STORAGE_KEY = exports.SESSION_STORAGE_KEY = 'configData';
const TTL = exports.TTL = 1200; // 20 minutes in seconds
const TTL_MILLISECONDS = exports.TTL_MILLISECONDS = TTL * 1000; // 20 minutes in milliseconds